class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.hiddenWhatsappWidgets = [];

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    setTimeout(() => {if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').openSubDrawer()});//cart-sub-drawer new added

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer-open');
    document.documentElement.classList.add('cart-drawer-open');
    this.hideWhatsappWidgets();
  }

  close() {
    if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').closeSubDrawer();//cart-sub-drawer new added
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('cart-drawer-open');
    document.documentElement.classList.remove('cart-drawer-open');
    this.restoreWhatsappWidgets();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  hideWhatsappWidgets() {
    const hiddenNodes = new Set(this.hiddenWhatsappWidgets.map(({ node }) => node));
    const candidates = Array.from(document.querySelectorAll('body *'));

    candidates.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (hiddenNodes.has(node)) return;
      if (this.contains(node)) return;
      if (node.closest('header-drawer, menu-drawer, cart-drawer')) return;

      const style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return;

      const fingerprint = [
        node.tagName,
        node.id || '',
        String(node.className || ''),
        node.getAttribute('aria-label') || '',
        node.getAttribute('title') || '',
        node.getAttribute('data-testid') || '',
        node.getAttribute('href') || '',
        node.getAttribute('src') || '',
      ]
        .join(' ')
        .toLowerCase();

      const isWhatsapp = /(whatsapp|whatflow|wa\.me|api\.whatsapp|myshop)/.test(fingerprint);
      if (!isWhatsapp) return;

      const rect = node.getBoundingClientRect();
      const nearEdge =
        rect.left <= 48 ||
        rect.right >= window.innerWidth - 48 ||
        rect.bottom >= window.innerHeight - 48 ||
        rect.top <= 48;
      const isFloating =
        style.position === 'fixed' ||
        style.position === 'sticky' ||
        style.position === 'absolute' ||
        node.tagName === 'IFRAME';

      if (!isFloating && !nearEdge) return;

      this.hiddenWhatsappWidgets.push({
        node,
        display: node.style.display,
        pointerEvents: node.style.pointerEvents,
        opacity: node.style.opacity,
        visibility: node.style.visibility,
      });

      node.style.display = 'none';
      node.style.pointerEvents = 'none';
      node.style.opacity = '0';
      node.style.visibility = 'hidden';
    });
  }

  restoreWhatsappWidgets() {
    if (!this.hiddenWhatsappWidgets.length) return;

    this.hiddenWhatsappWidgets.forEach(({ node, display, pointerEvents, opacity, visibility }) => {
      if (!(node instanceof HTMLElement)) return;
      node.style.display = display;
      node.style.pointerEvents = pointerEvents;
      node.style.opacity = opacity;
      node.style.visibility = visibility;
    });

    this.hiddenWhatsappWidgets = [];
  }

}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerDiscount extends HTMLElement {
  static flashStorageKey = 'cart-drawer-discount-flash';

  constructor() {
    super();
    this.details = this.querySelector('details');
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="discount"]');
    this.submitButton = this.querySelector('button[type="submit"]');
    this.clearButton = this.querySelector('[data-discount-clear]');
    this.message = this.querySelector('[data-discount-message]');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    if (this.clearButton) {
      this.clearButton.addEventListener('click', this.onClear.bind(this));
    }
  }

  connectedCallback() {
    this.showFlashMessage();
  }

  getCurrentDiscountSignature() {
    try {
      return JSON.stringify(JSON.parse(this.dataset.discountSignature || '[]'));
    } catch (error) {
      return '[]';
    }
  }

  getCurrentTotal() {
    return Number(this.dataset.totalPrice || 0);
  }

  getDiscountCount(signature = this.getCurrentDiscountSignature()) {
    try {
      return JSON.parse(signature).length;
    } catch (error) {
      return 0;
    }
  }

  hasExistingDiscounts() {
    return this.getDiscountCount() > 0;
  }

  getAppliedCodes() {
    try {
      const parsed = JSON.parse(this.dataset.appliedCodes || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((value) => (typeof value === 'string' ? value.trim() : ''))
        .filter((value) => value.length > 0);
    } catch (error) {
      return [];
    }
  }

  getMergeableCodes() {
    const codePattern = /^[A-Za-z0-9._-]+$/;
    return this.getAppliedCodes().filter((code) => codePattern.test(code));
  }

  buildDiscountPayload(rawDiscount) {
    const normalizedDiscount = rawDiscount.trim();
    if (!normalizedDiscount) return '';
    if (normalizedDiscount.includes(',')) return normalizedDiscount;

    const mergeableCodes = this.getMergeableCodes();
    if (!mergeableCodes.length) return normalizedDiscount;

    const existingSet = new Set(mergeableCodes.map((code) => code.toLowerCase()));
    if (existingSet.has(normalizedDiscount.toLowerCase())) {
      return mergeableCodes.join(',');
    }

    return [...mergeableCodes, normalizedDiscount].join(',');
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;

    this.submitButton.disabled = isLoading;
    this.submitButton.classList.toggle('loading', isLoading);
    const spinner = this.submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);

    if (this.clearButton) {
      this.clearButton.disabled = isLoading;
    }
  }

  setMessage(message = '', state = '') {
    if (!this.message) return;

    this.message.textContent = message;
    this.message.classList.remove('hidden', 'is-error', 'is-success');

    if (!message) {
      this.message.classList.add('hidden');
      return;
    }

    if (state) this.message.classList.add(`is-${state}`);
  }

  async onSubmit(event) {
    event.preventDefault();
    await this.applyDiscount(this.input ? this.input.value.trim() : '');
  }

  async onClear() {
    if (this.input) this.input.value = '';
    await this.applyDiscount('');
  }

  async applyDiscount(discount) {
    const normalizedDiscount = discount.trim();
    const discountPayload = this.buildDiscountPayload(normalizedDiscount);

    if (!normalizedDiscount && !this.hasExistingDiscounts()) {
      this.setMessage('Escribe un codigo para aplicar un descuento.', 'error');
      return;
    }

    this.setMessage();
    this.setLoading(true);

    try {
      const previousCart = await this.fetchCartState();
      const previousSignature = this.serializeCartState(previousCart);

      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ discount: discountPayload }),
      });
      const cart = await response.json();

      if (!response.ok) {
        throw new Error(cart.description || cart.message || 'No pudimos actualizar el descuento.');
      }

      const nextSignature = this.serializeCartState(cart);
      const nextDiscountCount = this.countDiscountsInCart(cart);
      const previousDiscountCount = this.countDiscountsInCart(previousCart);
      const cartChanged = nextSignature !== previousSignature;
      const applySucceeded = normalizedDiscount !== '' && cartChanged && nextDiscountCount > 0;
      const clearSucceeded = normalizedDiscount === '' && cartChanged && nextDiscountCount < previousDiscountCount;

      if (applySucceeded || clearSucceeded) {
        this.storeFlashMessage({
          state: 'success',
          message: applySucceeded
            ? 'Descuento aplicado. Tu total ya se actualizo en el carrito.'
            : 'Descuentos eliminados del carrito.',
        });
        await this.refreshDrawer();
        return;
      }

      if (normalizedDiscount !== '' && !cartChanged && nextDiscountCount > 0) {
        this.setMessage('Ese descuento ya esta activo en el carrito.', 'success');
        return;
      }

      if (normalizedDiscount === '' && previousDiscountCount > 0) {
        this.setMessage('No pudimos quitar los descuentos desde el carrito.', 'error');
        return;
      }

      this.setMessage('El descuento ingresado no aplica para este carrito.', 'error');
    } catch (error) {
      this.setMessage(error.message || 'No pudimos actualizar el descuento.', 'error');
    } finally {
      this.setLoading(false);
    }
  }

  async refreshDrawer() {
    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const replacements = ['#CartDrawer-GoalProgress', 'cart-drawer-items', '.cart-drawer__footer'];
    replacements.forEach((selector) => {
      const target = document.querySelector(selector);
      const source = html.querySelector(selector);
      if (target && source) target.replaceWith(source);
    });

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    const sourceCartIconBubble = html.getElementById('cart-icon-bubble');
    if (cartIconBubble && sourceCartIconBubble) {
      cartIconBubble.innerHTML = sourceCartIconBubble.innerHTML;
    }
  }

  async fetchCartState() {
    const response = await fetch(`${routes.cart_url}.js`, {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('No pudimos revisar el estado actual del carrito.');
    }

    return response.json();
  }

  countDiscountsInCart(cart) {
    const cartLevel = (cart.cart_level_discount_applications || []).length;
    const lineLevel = (cart.items || []).reduce((total, item) => {
      return total + (item.line_level_discount_allocations || []).length;
    }, 0);

    return cartLevel + lineLevel;
  }

  serializeCartState(cart) {
    return JSON.stringify({
      total_price: cart.total_price,
      items_subtotal_price: cart.items_subtotal_price,
      cart_level_discount_applications: (cart.cart_level_discount_applications || []).map((discount) => ({
        title: discount.title,
        total_allocated_amount: discount.total_allocated_amount,
      })),
      items: (cart.items || []).map((item) => ({
        key: item.key,
        final_line_price: item.final_line_price,
        line_level_total_discount: item.line_level_total_discount,
        line_level_discount_allocations: (item.line_level_discount_allocations || []).map((allocation) => ({
          title: allocation.discount_application?.title,
          amount: allocation.amount,
        })),
      })),
    });
  }

  storeFlashMessage(payload) {
    try {
      window.sessionStorage.setItem(CartDrawerDiscount.flashStorageKey, JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  showFlashMessage() {
    try {
      const rawMessage = window.sessionStorage.getItem(CartDrawerDiscount.flashStorageKey);
      if (!rawMessage) return;

      const payload = JSON.parse(rawMessage);
      if (payload?.message) {
        if (this.details) this.details.open = true;
        this.setMessage(payload.message, payload.state || 'success');
      }

      window.sessionStorage.removeItem(CartDrawerDiscount.flashStorageKey);
    } catch (error) {
      window.sessionStorage.removeItem(CartDrawerDiscount.flashStorageKey);
    }
  }
}

customElements.define('cart-drawer-discount', CartDrawerDiscount);


/**** cart-sub-drawer ****/
class SubCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.sub_drawer__close').addEventListener('click', this.closeSubDrawer.bind(this));
  }

   closeSubDrawer(){
    this.classList.remove('active')
  }

  openSubDrawer(){
    this.classList.add('animate', 'active')
  }
}

customElements.define('subcart-drawer', SubCartDrawer);
